export default function headingStrikeThroughInit() {
    function isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }

    $(window).scroll(function () {
        $(".section-heading").each(function () {
            if (isScrolledIntoView(this) === true) {
                $(this).addClass("strikethrough");
            } else {
                $(this).removeClass("strikethrough");
            }
        });
    });
}
